export class PlacardOptionsResponse {
    placardType: KeyValue[];
    placardSize: KeyValue[];
}

export class KeyValue {
    key: string;
    value: string;    
}